import React from 'react';
import { HelpCircle } from 'lucide-react';

const AjudaTab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
          <HelpCircle className="text-blue-600" />
          Central de Ajuda
        </h2>

        <div className="space-y-6">
          <div className="bg-blue-50 p-6 rounded-lg">
            <h3 className="font-bold text-blue-800 mb-4">Perguntas Frequentes</h3>
            <div className="space-y-4">
              <details className="bg-white p-4 rounded border">
                <summary className="font-medium cursor-pointer">
                  Como funciona o cálculo automático de datas?
                </summary>
                <p className="mt-2 text-sm text-gray-600">
                  O sistema calcula automaticamente todas as datas com base na data de término do mandato atual, 
                  respeitando rigorosamente os prazos mínimos estabelecidos pela NR-05.
                </p>
              </details>
              
              <details className="bg-white p-4 rounded border">
                <summary className="font-medium cursor-pointer">
                  Como funciona o sistema de votação online?
                </summary>
                <p className="mt-2 text-sm text-gray-600">
                  O sistema permite votação eletrônica com autenticação de eleitores, garantindo voto secreto e 
                  seguro conforme Art. 5.5.3(h) da NR-05. Gera automaticamente o ranking dos candidatos por ordem 
                  decrescente de votos.
                </p>
              </details>
              
              <details className="bg-white p-4 rounded border">
                <summary className="font-medium cursor-pointer">
                  Como garantir conformidade com a NR-05?
                </summary>
                <p className="mt-2 text-sm text-gray-600">
                  O sistema foi desenvolvido com base na NR-05 vigente (Portaria MTP nº 4.219/2022) e calcula 
                  automaticamente todos os prazos. Seguindo o cronograma e executando as ações listadas, você 
                  estará 100% conforme.
                </p>
              </details>
            </div>
          </div>

          <div className="bg-green-50 p-6 rounded-lg">
            <h3 className="font-bold text-green-800 mb-4">Guia Rápido de Uso</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-3">
                <div className="bg-white p-3 rounded border-l-4 border-blue-500">
                  <h4 className="font-medium text-blue-800">1. Configure a Data</h4>
                  <p className="text-sm text-gray-600">
                    Informe a data de término do mandato atual na tela inicial
                  </p>
                </div>
                <div className="bg-white p-3 rounded border-l-4 border-green-500">
                  <h4 className="font-medium text-green-800">2. Acompanhe o Cronograma</h4>
                  <p className="text-sm text-gray-600">
                    Siga as fases na aba Cronograma e marque as ações concluídas
                  </p>
                </div>
                <div className="bg-white p-3 rounded border-l-4 border-purple-500">
                  <h4 className="font-medium text-purple-800">3. Execute a Votação</h4>
                  <p className="text-sm text-gray-600">
                    Use o sistema de votação online para realizar a eleição
                  </p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="bg-white p-3 rounded border-l-4 border-orange-500">
                  <h4 className="font-medium text-orange-800">4. Monitore Status</h4>
                  <p className="text-sm text-gray-600">
                    Acompanhe alertas e status das fases na Dashboard
                  </p>
                </div>
                <div className="bg-white p-3 rounded border-l-4 border-red-500">
                  <h4 className="font-medium text-red-800">5. Gere Documentos</h4>
                  <p className="text-sm text-gray-600">
                    Baixe modelos e checklists prontos na aba Documentos
                  </p>
                </div>
                <div className="bg-white p-3 rounded border-l-4 border-indigo-500">
                  <h4 className="font-medium text-indigo-800">6. Gere Relatórios</h4>
                  <p className="text-sm text-gray-600">
                    Acesse relatórios de conformidade e progresso
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="font-bold text-gray-800 mb-4">Precisa de Mais Ajuda?</h3>
            <div className="text-center">
              <p className="text-gray-600 mb-4">
                Este sistema foi desenvolvido para garantir 100% de conformidade com a NR-05. 
                Todas as funcionalidades são baseadas na legislação vigente.
              </p>
              <div className="bg-blue-600 text-white p-4 rounded-lg inline-block">
                <p className="font-medium">Garantia de Conformidade</p>
                <p className="text-sm text-blue-100">Sistema à prova de autuações por descumprimento da NR-05</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AjudaTab;
